import { render, staticRenderFns } from "./_.vue?vue&type=template&id=29f2a3ea&"
import script from "./_.vue?vue&type=script&lang=ts&"
export * from "./_.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentsBlocks: require('/home/vsts/work/1/a/NuxtApp/components/contents/Blocks.vue').default,ProductListerBanner: require('/home/vsts/work/1/a/NuxtApp/components/product/lister/Banner.vue').default,ProductListerAbout: require('/home/vsts/work/1/a/NuxtApp/components/product/lister/About.vue').default,ProductListerCategoryTiles: require('/home/vsts/work/1/a/NuxtApp/components/product/lister/CategoryTiles.vue').default,ProductLister: require('/home/vsts/work/1/a/NuxtApp/components/product/lister/index.vue').default})
